<template>
  <Frame>
    <PageHeader :title="$t('salSalesOrder.urgentApplay')" :hasBack="true" />
    <span style="width: 100%;color:red;font-size: 14px;font-weight: bolder;">{{ $t('salSalesOrder.urgentWarnText') }}</span>
    <el-table :data="tableData" :height="tableHeight" style="margin:0;width:100%" v-loading="tableLoading">
      <el-table-column type="index" width="50" :label="$t('orderImport.rowNo')"></el-table-column>
      <el-table-column :width="100" :label="$t('salSalesOrder.urgentLevel')">
        <template scope="scope">
          <el-select size="small" v-model="scope.row.X_UrgentType">
            <el-option v-for="item in urgentTypeList" :key="item.value" :label="item.label" :value="item.value"
              :disabled="item.disabled"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column :min-width="200" prop="X_UrgentText"
        :label="$t('salSalesOrder.urgentReson')">
        <template scope="scope">
          <el-input type="textarea" :rows="2" :placeholder="$t('salSalesOrder.inputpls')" maxlength="200"
            v-model="scope.row.X_UrgentText"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="X_UrgentDate" :width="160" :label="$t('salSalesOrder.hopeDate')">
        <template scope="scope">
          <el-date-picker v-model="scope.row.X_UrgentDate" type="date"></el-date-picker>
        </template>
      </el-table-column>
      <el-table-column :min-width="WidthControl('BillNo', tableData)" prop="BillNo"
        :label="$t('salSalesOrder.orderNo')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_CustNumberOrg', tableData)" prop="X_CustNumberOrg"
        :label="$t('salSalesOrder.customerNo2')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_BPMaterialSpec', tableData)" prop="X_BPMaterialSpec"
        show-overflow-tooltip :label="$t('salSalesOrder.meterialSpe')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_TotalSQty', tableData)" prop="X_TotalSQty" align="right"
        :label="$t('salSalesOrder.sQty')"></el-table-column>
      <el-table-column :min-width="WidthControl('BillDate', tableData)" prop="BillDate"
        :label="$t('salSalesOrderDetail.messagedate')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_PreDate', tableData)" prop="X_PreDate"
        :label="$t('salSalesOrder.preDate')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_NewDate', tableData)" prop="X_NewDate"
        :label="$t('salSalesOrder.newDate2')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_SupId', tableData)" prop="X_SupId"
        :label="$t('salSalesOrder.supplier')"></el-table-column>
    </el-table>

    <div class="footer-contain">
      <div class="btnarray">
        <el-button type="primary" @click="commit" :disabled="tableLoading" :title="$t('salSalesOrder.commitBtn')">{{
    $t('salSalesOrder.commitBtn')
          }}</el-button>
      </div>
    </div>
  </Frame>
</template>

<script>
import { listMixin } from "@/agency/mixin/mixin.js";
import { handleShortDate } from "@/utils/handleDate";
export default {
  name: "UrgentApply",
  mixins: [listMixin],
  data() {
    return {
      tableHeight: window.innerHeight - 260,
      BillNos: "",
      urgentTypeList: [
        { value: 0, label: " " },
        { value: 2, label: this.$t("salSalesOrder.urgentLevel1") },
        { value: 3, label: this.$t("salSalesOrder.urgentLevel2") }
      ]
    };
  },
  props: {
    GetListData: {
      type: Function,
      default: function (...arg) {
        this.getListData(...arg);
      }
    }
  },
  mounted() {
    this.frameOnResize(260);
  },
  created() {
    this.BillNos = this.$route.query.BillNos;
    this.getListData();
  },
  methods: {
    getListData() {
      this.tableLoading = true;
      this.axiosInvoke(
        this.sysHandlerUrl,
        {
          action: "getsalsalesorder",
          BillNos: this.BillNos,
          pageIndex: 0,
          pageSize: 10
        },
        res => {
          const data = res.data;
          this.tableLoading = false;
          data.DataTable.forEach(element => {
            element.X_UrgentType = 2;
            element.X_UrgentText = '';
            element.X_UrgentDate = '';
          });
          this.tableData = data.DataTable;
        },
        false,
        true
      );
    },
    commit() {
      let errMsg = "";
      for (let i = 0; i < this.tableData.length; i++) {
        let curD = this.tableData[i];
        if (curD["X_UrgentType"] == 3 && !curD["X_UrgentText"]) {
          errMsg = this.$t("salSalesOrder.urgentError1")
          break;
        }
        let nowTime = new Date().getTime();

        if (curD["X_UrgentDate"]) {
          let urgentDate = new Date(curD["X_UrgentDate"]).getTime();
          if (nowTime > urgentDate) {
            errMsg = this.$t("salSalesOrder.urgentError2").replace("{0}", i + 1).replace("{1}", curD["BillNo"]);
            break;
          }

          let newDateTime = new Date(curD["X_NewDate"]).getTime();
          if (urgentDate > newDateTime) {
            errMsg = this.$t("salSalesOrder.urgentError3");
            break;
          }
          curD["X_UrgentDate"] = handleShortDate(curD["X_UrgentDate"]);
        }
      };
      if (errMsg) {
        this.$store.commit("TIPPOP", {
          popType: "warning",
          popMessage: errMsg
        });
      } else {
        this.tableLoading = true;
        this.axiosInvoke(
          this.sysHandlerUrl,
          {
            action: 'dourgentapply',
            ymAy: JSON.stringify(this.tableData)
          },
          res => {
            const data = res.data[0];
            this.tableLoading = false;
            
            if (data.state == 0) {
              this.$store.commit("TIPPOP", { popType: 'error', popMessage: data.message });
            } else {
              this.$alert(data.message, this.$t("comm.tipContent"), {
                confirmButtonText: this.$t("comm.confirm"),
                callback: action => {
                  this.$router.back();
                }
              });
            }
          },
          false,
          true
        );
      }
    }
  }
};
</script>
<style scoped>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

.el-table /deep/ .el-table__header .cell .el-checkbox:first-child {
  padding-left: 5px;
}

.footer-contain {
  display: flex;
  padding-top: 6px;
  justify-content: center;
}

.el-table /deep/ th.el-table__cell {
  background-color: #f9f9f9;
}

.el-table /deep/ thead {
  font-size: 14px;
  color: #5d5d5d;
}

.btnarray {
  margin-left: 7px;
}
</style>
